<template>
  <div v-html="webinarInfo.intro" class="wap-intro"></div>
</template>
<script>
import { $subscriber } from "fire-wind-water";
export default {
  name: "Info",
  data() {
    return {
      webinarInfo: {}
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      $subscriber.subscribe("webinarInfo", data => {
        this.webinarInfo = data;
      });
    }
  }
};
</script>
<style scoped lang="scss">
img {
  max-width: 100%;
}
</style>
